import { Storage } from '../Utils'

export const UserGuestMixin = {
    data() {
        return {
            isGuest: false,
        }
    },
    mounted() {
        this.isGuest = !!Storage.getGuest().isGuest

        window.addEventListener('onGuest', this.onGuestHandler)
        window.addEventListener('offGuest', this.offGuestHandler)
    },
    beforeDestroy() {
        window.removeEventListener("onGuest", this.onGuestHandler)
        window.removeEventListener('offGuest', this.offGuestHandler)
    },
    methods: {
        onGuestHandler() {
            Storage.setGuest({isGuest: true})
            this.$emit('onGuest')
            this.isGuest = true
        },
        offGuestHandler() {
            Storage.setGuest({isGuest: false})
            this.$emit('offGuest')
            this.isGuest = false
        }
    }
}
